import { useFormikContext } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { isVoxpayProvider } from 'Components/widgets/payment-info/payment-form/paymentProvidersUtils';
import { PaymentProvidersForm } from 'Components/widgets/payment-info/payment-form/PaymentProvidersForm';
import { VoxpayBlock } from 'Components/widgets/payment-info/b2b-payment-info/VoxpayBlock';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
import { Title } from 'Components/frameworks/title/Title';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { t } from 'Src/i18n';
import * as yup from 'yup';
import { DEPOSIT_OFFSET_PSP_ID } from 'Components/widgets/payment-info/PaymentInfo.const';
type Props = {
  hasPaymentProvidersMatchingBlock: boolean;
  displayNewPaymentProvidersImplementation: boolean;
  hasFullAmount: boolean;
  isDisabled: boolean;
  selectedPaymentProvider: PaymentProvider;
  paymentProviders: ReadonlyArray<PaymentProvider>;
  paymentSchedule: PaymentSchedule;
  shouldAutoSubmitForm: boolean;
  showPaymentMethodWithConditions: boolean;
};
export const B2BPaymentProvidersForm = ({
  hasPaymentProvidersMatchingBlock,
  displayNewPaymentProvidersImplementation,
  hasFullAmount,
  isDisabled,
  paymentProviders,
  selectedPaymentProvider,
  paymentSchedule,
  shouldAutoSubmitForm,
  showPaymentMethodWithConditions,
}: Props) => {
  const formik = useFormikContext();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const { paymentProviderId } = formik.values;
  const isVoxpayPaymentProvider = isVoxpayProvider(paymentProviderId);
  const hasPaymentMethods = !!selectedPaymentProvider.paymentMethods?.length;
  useEffect(() => {
    !hasPaymentMethods && formik.setFieldValue('paymentConditionId', '');
  }, [hasPaymentMethods]);
  useEffect(() => {
    setSelectedPaymentMethod(selectedPaymentProvider?.categoryPaymentMethod || '');
  }, [paymentProviderId]);
  // TO DO: check if we can delete this component to use common b2c method
  return (
    <Fragment>
      <PaymentProvidersForm
        displayNewPaymentProvidersImplementation={displayNewPaymentProvidersImplementation}
        hasFullAmount={hasFullAmount}
        isDisabled={isDisabled}
        paymentProviders={paymentProviders}
        paymentSchedule={paymentSchedule}
        shouldAutoSubmitForm={shouldAutoSubmitForm}
        showPaymentMethodWithConditions={showPaymentMethodWithConditions}
        onProviderSelection={setSelectedPaymentMethod}
      />
      {hasPaymentProvidersMatchingBlock && isVoxpayPaymentProvider && (
        <VoxpayBlock selectedPaymentMethod={selectedPaymentMethod} isDisabled={isDisabled} />
      )}
      {paymentProviderId === DEPOSIT_OFFSET_PSP_ID && (
        <div className="full mt-20 w-full">
          <Title className="mb-10">{t('booking.partners.banking.comments.title')}</Title>
          <Capsule header="none" contentClassName="p-20">
            <FormikInput
              placeholder={t('booking.partners.banking.comments.fieldPlaceholder')}
              name="comments"
              type="textarea"
              validate={yup.string().required(t('booking.partners.banking.comments.error'))}
            />
          </Capsule>
        </div>
      )}
    </Fragment>
  );
};
